import isString from "lodash/isString";
import { Inline, Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Pill } from "PFComponents/pill";
import { useTranslation } from "react-i18next";

import { ElementPill } from "../element_pill";
import css from "./availability_change_group.module.scss";
import { ChangelogElement } from "./hooks/use_availability_changelog.types";

type AvailabilityChangeGroupProps = {
  changelogElements: ChangelogElement[][];
};

export const AvailabilityChangeGroup = ({ changelogElements }: AvailabilityChangeGroupProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "notificationChangelog" });

  return (
    <Stack>
      {changelogElements.map((group, index) => (
        <Inline key={index} className={css.group} gap="spacingXs" wrap="wrap">
          {group.map((element, elementIndex) => (
            <Inline key={elementIndex} gap="spacingXs">
              {!!element.content && (
                <ElementPill
                  highlighted={!!element.highlighted}
                  title={isString(element.content) ? element.content : undefined}
                  noWrap
                >
                  {element.content}
                </ElementPill>
              )}
              {!!element.separator && <Divider type="vertical" />}
              {element.pill && (
                <Pill
                  text={element.pill === "added" ? t("added") : t("removed")}
                  kind={element.pill === "added" ? "success" : "danger"}
                  small
                />
              )}
            </Inline>
          ))}
        </Inline>
      ))}
    </Stack>
  );
};
